export default __webpack_public_path__ + "static/media/connectando-pessoas.94c1fb10.png";